import { copy, isEmpty } from 'rde-view-common/scripts/functions';

export default class StoreUtils {

  /**
   * ストアされたすべての値をクリアします。
   *
   * @param storeName ストアの名称。指定しない場合はすべて。
   */
  static clearAll(storeName) {
    this.$store.commit(`${storeName ? storeName + '/' : ''}clearAll`);
  }

  /**
   * すべてのストア情報をJSONStringで取得します。
   *
   * @returns {string|{}}
   */
  static getAllStatesAsString() {
    try {
      return JSON.stringify(this.$store.state);
    } catch {
      return {};
    }
  }

  /**
   * JSONStringで入力されたストア情報を復元します。
   *
   * @param statesStr ストア情報のJSONString
   */
  static setAllStates(statesStr) {
    const states = JSON.parse(statesStr);
    if (isEmpty(states)) return;
    Object.keys(states)
      .forEach(key => {
        try {
          this.$store.commit(key, states[key]);
        } catch {
          console.log(`undefined store(key: ${key})`);
        }
      });
  }

  /**
   * フォームの内容を保持します。
   *
   * @param formObj {{}} フォーム内容のオブジェクト
   * @param key default: 現在ページのパス
   */
  static storeForm(formObj, key = this.$currentPath) {
    this.$store.commit('storeForm', { key, formObj: copy(formObj) });
  }

  /**
   * 保持したフォームの内容を取得します。
   *
   * @param key default: 現在ページのパス
   * @returns {{}} フォーム内容のオブジェクト
   */
  static getForm(key = this.$currentPath) {
    const searchState = this.$store.state.searchState[key];
    return (isEmpty(searchState) || isEmpty(searchState.formObj)) ? {} : copy(searchState.formObj);
  }

  /**
   * 指定されたkeyのフォームの内容をクリアします。
   *
   * @param key default: 現在ページのパス
   */
  static clearForm(key = this.$currentPath) {
    this.$store.commit('clearForm', key);
  }

  /**
   * ソート条件を保持します。
   *
   * @param sortProps {{sortKey: String, isDesc: Boolean}} ソート条件のオブジェクト
   * @param key default: 現在ページのパス
   */
  static storeSortProps(sortProps, key = this.$currentPath) {
    this.$store.commit('storeSortProps', { key, sortProps });
  }

  /**
   * 保持したソート条件を取得します。
   *
   * @param key default: 現在ページのパス
   * @returns  {{sortKey: String, isDesc: Boolean}} ソート条件のオブジェクト
   */
  static getSortProps(key = this.$currentPath) {
    const searchState = this.$store.state.searchState[key];
    return isEmpty(searchState) || isEmpty(searchState.sortProps) ? {} : searchState.sortProps;
  }

  /**
   * 指定されたkeyのソート条件をクリアします。
   *
   * @param key default: 現在ページのパス
   */
  static clearSortProps(key = this.$currentPath) {
    this.$store.commit('clearSortProps', key);
  }

  /**
   * ページネーションの状態を保持します。
   *
   * @param paginationState  {{limit: Number, offset: Number}} ページネーションのオブジェクト
   * @param key default: 現在ページのパス
   */
  static storePagination(paginationState, key = this.$currentPath) {
    this.$store.commit('storePaginationState', { key, paginationState });
  }

  /**
   * 保持したページネーションの状態を取得します。
   *
   * @param key default: 現在ページのパス
   * @returns {*} フォーム内容のオブジェクト
   */
  static getPagination(key = this.$currentPath) {
    const searchState = this.$store.state.searchState[key];
    return isEmpty(searchState) || isEmpty(searchState.paginationState) ? {} : searchState.paginationState;
  }

  /**
   * 指定されたkeyのページネーションの状態をクリアします。
   *
   * @param key default: 現在ページのパス
   */
  static clearPagination(key = this.$currentPath) {
    this.$store.commit('clearPaginationState', key);
  }

  /**
   * 指定されたkeyの検索に関わる全ての条件をクリアします。
   *
   * @param key default: 現在ページのパス
   */
  static clearAllSearchState(key = this.$currentPath) {
    this.$store.commit('clearAllSearchState', key);
  }
}
